import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {forgotPassword} from '../../services/auth-service';
import MinimalLayout from "../../layouts/minimal";
import {ErrorMessage, Field, Form, Formik} from "formik";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {forgotPasswordRequestSchema} from "../../utils/schemas";
import {useGlobalNotificationMessage} from "../../context/message";
import {AppRoutes} from "../../utils/constants";

export default function ForgotPassword () {
  const [submitted, setSubmitted] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    forgotPassword({
      login: values.email
    }).then((responseData) => {
      setSubmitted(true);
    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage, "Password recovery failed.");
      HelperService.handleFormErrors(error, setErrors);
    }).finally(()=>{setSubmitting(false);});
  };

  return (
      <>
        <Section animation={HelperService.getRandomAnimation()} className="bg-image">

          <div className="container">
            <div className="row justify-content-center align-items-center h100 py-5">
              <div className="col-xxl-4 col-lg-5">

                <div className="text-center pb-5">
                  <Link to={AppRoutes.landing.path}>
                    <span><img src="/assets/images/logo.svg" alt="" height="120"/></span>
                  </Link>
                </div>

                <div className="card">

                  {submitted && <div className="card-body p-4">
                    <div className={"my-2 p-2 text-center"}>
                      <span className="mdi mdi-check-circle-outline mb-2 text-success" style={{'fontSize':'50px'}}></span><br />
                      <p>We have sent instructions to recover your password details to your email address.</p>
                    </div>
                  </div>}

                  {!submitted && <div className="card-body p-4">

                    <div className="text-center w-75 m-auto">
                      <h4 className="text-dark-50 text-center pb-0 fw-bold">Password recovery</h4>
                      <p className="text-muted mb-4">Please enter email of your account</p>
                    </div>

                    <Formik
                        initialValues={forgotPasswordRequestSchema.cast()}
                        validationSchema={forgotPasswordRequestSchema}
                        onSubmit={handleSubmit}
                    >
                      {({ isSubmitting, errors, touched }) => (
                          <Form>
                            <div className="mb-3">
                              <label htmlFor="email" className="form-label">Email</label>
                              <Field required
                                     name="email"
                                     type="email"
                                     placeholder="example@sweatnow.com"
                                     className={`form-control ${errors.email && touched.email ? "is-invalid":""}`} />
                              <ErrorMessage name="email" component="div" className="invalid-feedback" />
                            </div>

                            <div className={"text-center"}>
                              <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>Send</button>
                            </div>
                          </Form>
                      )}
                    </Formik>

                    <hr className={"mt-5 d-block"} />

                    <p className="text-center">
                      <Link to={AppRoutes.login.path} className={"link-dark"}>Back to login methods</Link>
                    </p>

                  </div>}

                </div>

              </div>
            </div>
          </div>

        </Section>
      </>
  );
}


ForgotPassword.getLayout = function getLayout(page) {
  return (
      <MinimalLayout>
        {page}
      </MinimalLayout>
  )
}
